<template>
  <div
    :class="{
      'h5-organization-courses': isH5,
      'pc-organization-courses': !isH5,
    }"
  >
    <div class="bg-img-wrap">
      <img
        class="bg-img-bg"
        v-if="orgInfo.org_bg_pic"
        :src="orgBgPic + '|imageMogr2/blur/50x50'"
        alt=""
      />
      <img class="bg-img" :src="orgBgPic" alt="背景图" />
    </div>
    <div class="page-cont">
      <!-- 机构信息 -->
      <div class="org-info-wrap">
        <div class="org-info">
          <img class="org-logo" :src="orgLogo" alt="logo" />
          <div class="org-name-wrap">
            <p class="org-name">
              {{ orgInfo.org_name }}
            </p>
            <p class="introduce">
              {{ orgInfo.org_desc }}
            </p>
          </div>
          <button class="go-home-btn" @click="jumpOrgHome">主页</button>
        </div>
        <el-input
          class="search-input"
          placeholder="搜索课程"
          size="medium"
          v-model.trim="keyword"
          @keyup.enter.native="onSearch"
          maxlength="100"
        >
          <i
            :slot="isH5 ? 'prefix' : 'suffix'"
            class="el-input__icon el-icon-search"
            @click.stop="onSearch"
          ></i>
        </el-input>
      </div>
      <div class="type-list-wrap" v-show="!inIosReview">
        <div class="type-list">
          <span
            @click="handleTypeChange(item.type)"
            v-for="item in typeList"
            :key="item.type"
            :class="{ 'is-active': type === item.type }"
            class="type-item"
            >{{ item.name }}</span
          >
        </div>
        <el-dropdown @command="handleMenuBehavior">
          <span class="el-dropdown-link">
            排序<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="0">推荐排序</el-dropdown-item>
            <el-dropdown-item command="1">价格从低到高</el-dropdown-item>
            <el-dropdown-item command="2">价格从高到低</el-dropdown-item>
            <el-dropdown-item command="3">报名人数从少到多</el-dropdown-item>
            <el-dropdown-item command="4">报名人数从多到少</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!-- 列表 -->
      <div class="content-wrap" v-if="courseList.length">
        <CourseCardOrg
          class="org-course-card"
          v-for="item in courseList"
          :key="item.id"
          :courseInfo="item"
          type="small"
        />
      </div>
      <el-empty
        v-else
        description="暂无内容"
        :image="require('@/assets/img/live-list/empty.png')"
      ></el-empty>
    </div>
  </div>
</template>

<script>
import { getOrganization } from "@saas/server-api/src/organization";
import { getCourseList } from "@saas/server-api/src/course";
import { CourseCardOrg, isH5, getCdnUrl } from "@saas/components/src";
export default {
  data: function () {
    let typeList = [
      {
        type: 0,
        name: "全部",
      },
      {
        type: 1,
        name: "免费",
      },
      {
        type: 2,
        name: "收费",
      },
    ];
    return {
      keyword: "",
      type: 0,
      courseList: [],
      page_no: 1,
      page_size: 18,
      order_by: 0,
      noMore: false, //没有更多
      loading: false, //加载数据中
      orgInfo: {},
      isH5: isH5(),
      typeList: typeList,
      inIosReview: false,
    };
  },
  created() {
    this.inIosReview = this.$route.query?.inReview === "1";
  },
  mounted() {
    if (this.$route.query.keyword) {
      this.keyword = this.$route.query.keyword;
      // 清空参数
      this.$route.query.keyword = "";
    }
    this.apiGetCourseList();
    // 获取机构信息
    this.apiGetOrganization();

    this.$nextTick(() => {
      setTimeout(() => {
        if (window.isElectron) {
          let elMain = document.getElementById("electron-main");
          if (!elMain) return;
          elMain.addEventListener("scroll", this.handleElScrollFn, true);
        } else {
          window.addEventListener("scroll", this.scrollFn, true); //监听页面滚动
        }
      }, 2000);
    });
  },
  computed: {
    orgBgPic() {
      if (this.orgInfo?.org_bg_pic) {
        return this.orgInfo?.org_bg_pic + "?imageView2/0/w/1000";
      } else {
        return require("../../assets/images/organization/org_bg.png");
      }
    },
    orgLogo() {
      if (this.orgInfo?.org_logo) {
        return this.orgInfo?.org_logo + "?imageView2/0/w/160";
      } else {
        return getCdnUrl("/cdn/static/images/default_org_logo.png", "?imageView2/0/w/100", "comettech");
      }
    },
  },
  beforeDestroy() {
    if (window.isElectron) {
      let elMain = document.getElementById("electron-main");
      if (!elMain) return;
      elMain.removeEventListener("scroll", this.handleElScrollFn, true);
    } else {
      window.removeEventListener("scroll", this.scrollFn, true); //销毁滚动事件
    }
  },
  methods: {
    jumpOrgHome() {
      let url = `/org/${this.$route.params.org_id}`;
      if (this.$route.query?.inReview === "1") {
        url = `${url}?inReview=1`;
      }
      this.$router.push(url);
    },
    apiGetOrganization() {
      getOrganization({ org_id: this.$route.params.org_id }).then((res) => {
        if (res.code === 1 && res.data) {
          this.orgInfo = res.data;
        }
      });
    },
    handleMenuBehavior(command) {
      this.page_no = 1;
      this.order_by = command;
      this.apiGetCourseList();
    },
    apiGetCourseList() {
      this.loading = true;
      let params = {
        page_no: this.page_no,
        page_size: this.page_size,
        org_id: this.$route.params.org_id,
        course_name: this.keyword,
        fee_type: this.type || "",
        order_by: Number(this.order_by) || "",
      };
      getCourseList(params)
        .then((res) => {
          if (res.code === 1) {
            if (res.data && res.data.list) {
              if (params.page_no === 1) {
                this.courseList = res.data.list;
              } else {
                this.courseList = this.courseList.concat(res.data.list);
              }
              if (this.courseList.length === res.data.total) {
                this.noMore = true;
              } else {
                this.noMore = false;
              }
            }
          } else {
            this.$message.error(res.message);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onSearch() {
      this.page_no = 1;
      this.apiGetCourseList();
    },
    handleTypeChange(type) {
      this.type = type;
      this.page_no = 1;
      this.apiGetCourseList();
    },
    handleElScrollFn(event) {
      if (this.loading || this.noMore) return false;
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 触底-加载下一页
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.loading = true;
        this.page_no++;
        this.apiGetCourseList();
      }
    },
    scrollFn() {
      if (this.loading) return false;
      //获取网页的总高度
      var htmlHeight =
        document.body.scrollHeight || document.documentElement.scrollHeight;
      //clientHeight是网页在浏览器中的可视高度
      var clientHeight =
        document.body.clientHeight || document.documentElement.clientHeight;
      //scrollTop是浏览器滚动条的top位置
      var scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      //判断到底部了
      if (scrollTop + clientHeight > htmlHeight - 100) {
        if (!this.noMore) {
          this.page_no++;
          this.apiGetCourseList();
        }
      }
    },
  },
  components: {
    CourseCardOrg,
  },
};
</script>

<style lang="scss" scoped>
.pc-organization-courses {
  background: #fafafa;
  width: 100%;
  min-height: calc(100vh - 70px);
  .bg-img-wrap {
    position: relative;
    background: #d4f1e1;
    height: 340px;
    .bg-img-bg {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .bg-img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 800px;
      height: 340px;
      object-fit: cover;
    }
  }
  .page-cont {
    position: relative;
    top: -20px;
    max-width: 800px;
    width: 800px;
    margin: 0 auto;
  }
  .org-info-wrap {
    position: relative;
    top: -20px;
    padding: 20px;
    border-radius: 24px;
    background: #fff;
    padding: 20px 24px;

    .go-home-btn {
      width: 66px;
      height: 28px;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      line-height: 28px;
      text-align: center;
      border-radius: 14px;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      margin-left: 8px;
    }

    .org-logo {
      width: 80px;
      height: 80px;
      border-radius: 16px;
      border: 1px solid #e2e2e2;
      margin-right: 16px;
      object-fit: cover;
    }
    .org-info {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      .org-name-wrap {
        width: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .org-name {
        font-weight: 500;
        font-size: 20px;
        color: #000000;
        line-height: 28px;
        word-break: break-all;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .introduce {
        font-weight: 400;
        font-size: 16px;
        color: #515350;
        line-height: 22px;
        margin-top: 6px;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
    .search-input {
      color: #0d1400;
    }
    ::v-deep .search-input input {
      background: #fafafa;
      border-radius: 8px;
    }
    ::v-deep .el-input__inner {
      border: none;
    }
    ::v-deep .el-input__inner::placeholder {
      color: #888988;
    }
  }

  .type-list-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 25px;
    // padding: 7px 0 0;
    .type-item {
      cursor: pointer;
      display: inline-block;
      font-weight: 400;
      font-size: 18px;
      color: #515350;
      line-height: 25px;
      padding: 10px;
      margin-right: 22px;
    }
    .is-active {
      position: relative;
      font-weight: 600;
      color: #0d1400;
      &::after {
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        display: block;
        content: "";
        width: 19px;
        height: 4px;
        background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
        border-radius: 3px;
      }
    }
    .el-dropdown-link {
      font-size: 18px;
      color: #747573;
      line-height: 25px;
    }
  }

  .content-wrap {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}

.h5-organization-courses {
  background: #fafafa;
  width: 100%;
  min-height: calc(100vh - 1.6rem);
  .bg-img-wrap {
    position: relative;
    background: #d4f1e1;
    height: 4.24rem;
    .bg-img-bg {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .bg-img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 10rem;
      height: 4.24rem;
      object-fit: cover;
    }
  }
  .page-cont {
    position: relative;
    top: -0.13rem;
    max-width: 100%;
    width: 100%;
    margin: 0 auto;
    padding: 0 0.32rem;
  }
  .org-info-wrap {
    position: relative;
    top: -0.27rem;
    padding: 20px;
    border-radius: 0.32rem;
    background: #fff;
    padding: 0.32rem 0.27rem 0.27rem;

    .go-home-btn {
      width: 1.17rem;
      height: 0.64rem;
      font-weight: 500;
      font-size: 0.32rem;
      color: #ffffff;
      line-height: 0.64rem;
      text-align: center;
      border-radius: 0.21rem;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    }

    .org-logo {
      width: 1.2rem;
      height: 1.2rem;
      border-radius: 0.21rem;
      border: 0.01rem solid #e2e2e2;
      margin-right: 0.16rem;
      object-fit: cover;
    }
    .org-info {
      display: flex;
      align-items: center;
      margin-bottom: 0.21rem;
      .org-name-wrap {
        width: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .org-name {
        font-weight: 500;
        font-size: 0.4rem;
        color: #0d1400;
        line-height: 0.56rem;
        word-break: break-all;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .introduce {
        font-weight: 400;
        font-size: 0.29rem;
        color: #515350;
        line-height: 0.4rem;
        margin-top: 0.13rem;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
    .search-input {
      color: #0d1400;
    }
    ::v-deep .search-input input {
      background: #fafafa;
      border-radius: 0.21rem;
    }
    ::v-deep .el-input__inner {
      border: none;
    }
    ::v-deep .el-input__inner::placeholder {
      color: #888988;
    }
  }
  .type-list-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.15rem;
    .type-item {
      display: inline-block;
      font-weight: 400;
      font-size: 0.37rem;
      color: #515350;
      line-height: 0.53rem;
      padding: 0.13rem;
      margin-right: 0.27rem;
    }
    .is-active {
      position: relative;
      font-weight: 500;
      color: #0d1400;
      &::after {
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        display: block;
        content: "";
        width: 0.27rem;
        height: 0.05rem;
        background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
        border-radius: 0.07rem;
      }
    }
    .el-dropdown-link {
      font-size: 0.37rem;
      color: #747573;
      line-height: 0.53rem;
    }
  }
  .content-wrap {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}
</style>
